import { useImpersonation } from "@/contexts/ImpersonationContext";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Eye, X } from "lucide-react";

export function ImpersonationBanner() {
  const { isImpersonating, impersonatedEmail, stopImpersonation } = useImpersonation();
  const navigate = useNavigate();

  if (!isImpersonating) return null;

  const handleExit = () => {
    stopImpersonation();
    navigate("/admin");
  };

  return (
    <div className="fixed top-0 left-0 right-0 z-[60] bg-brand-deep-purple text-white px-4 py-2 flex items-center justify-center gap-3 text-sm font-medium shadow-md">
      <Eye className="h-4 w-4 shrink-0" />
      <span className="truncate">Viewing as {impersonatedEmail}</span>
      <Button
        size="sm"
        variant="outline"
        className="h-7 gap-1 bg-brand-deep-purple/10 border-brand-deep-purple/30 text-white hover:bg-brand-deep-purple/20 shrink-0"
        onClick={handleExit}
      >
        <X className="h-3 w-3" />
        Exit
      </Button>
    </div>
  );
}
